import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/ui";

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div data-testid="not-found-page" className="flex h-full w-full flex-col items-center justify-center p-6">
      <h1
        data-testid="not-found-title"
        className="font-chakra text-primary text-[220px] leading-none font-bold tracking-[-0.7px]"
      >
        404
      </h1>
      <h2
        data-testid="not-found-subtitle"
        className="font-inter text-[28px] leading-none font-medium tracking-[-0.7px]"
      >
        Page not found
      </h2>
      <Button data-testid="not-found-home-button" className="mt-10 w-full max-w-45" onClick={() => navigate("/")}>
        Go to main
      </Button>
    </div>
  );
}
